<template>
  <div>
    <div class="global-pagination-wrap pagination-right" v-if="total > 0 && !pageSizes">
      <el-pagination background small @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-size="pageSize" :pager-count="pageCount" :prev-text="$t('commonMsg.prev')"
        :next-text="$t('commonMsg.next')" :layout="layout" :total="total" />
    </div>
    <div class="global-pagination-wrap pagination-right" v-if="pageSizes && total > 0">
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="[20, 50, 100]" :page-size="pageSize" :pager-count="pageCount"
        :prev-text="$t('commonMsg.prev')" :next-text="$t('commonMsg.next')" layout="sizes, prev, pager, next, jumper"
        :total="total" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    layout: {
      type: String,
      default: "total, prev, pager, next, jumper"
    },
    pageSize: {
      type: Number,
      default: 20
    },
    pageSizes: {
      type: Boolean,
      default: false
    },
    pageCount: {
      type: Number,
      default: 5
    },
    total: {
      type: Number
    },
    currentPage: {
      type: Number,
      default: 1
    }
  },
  computed: {},
  methods: {
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.$emit("pageSize", val);
    },
    handleCurrentChange(val) {
      this.$emit("pageNum", val);
    }
  }
};
</script>

<style scoped>
.pagination-right {
  justify-content: flex-end !important;
  width: auto !important;
  margin-left: auto;
}

.global-pagination-wrap {
  width: auto !important;
  display: inline-flex !important;
}
</style>
